// frontend/src/components/common/LoadingSpinner.js

import React from 'react';
// فرض بر نصب بودن lucide-react (برای آیکون Loader)
import { Loader } from 'lucide-react'; 

const LoadingSpinner = ({ text = "درحال بارگذاری..." }) => {
    return (
        <div className="flex items-center justify-center text-indigo-600 p-6 rtl">
            <Loader size={24} className="animate-spin ml-2" />
            <span className="text-[11px] font-medium">{text}</span>
        </div>
    );
};

export default LoadingSpinner;